import ProductPlacement from '../product-placement';

export default class OtherProductPlacement extends ProductPlacement {
  obstaclesPresent?: boolean;
  obstaclesInfo?: string;
}
